export { default as AdVisitedLabel } from './AdVisitedLabel';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdVisitedLabel/index.ts